import { DesignInput, DesignInputSpeakAs, VariableType } from '../../../../types';

export function getPromptInputHauless(varName: string): DesignInput {
  return {
    argumentName: varName,
    varName: varName,
    type: VariableType.variable,
    value: null,
    sensitiveData: false,
    speakAs: DesignInputSpeakAs.asIs,
    defaultValue: ''
  };
}
